  <header vid="7">
        <div class="hero-label" vid="8">{{ route.name }}</div>
        <h1 class="hero-title" vid="9">{{ route.location }}</h1>
    </header>

    <section class="summary-card" vid="10">
        <div class="summary-stats" vid="11">
            <div class="stat-item" vid="12">
                <span class="stat-value" vid="13">{{ progress.stops }}</span>
                <span class="stat-label" vid="14">Stops</span>
            </div>
            <div class="stat-item" vid="15">
                <span class="stat-value" vid="16">{{ progress.packages }}</span>
                <span class="stat-label" vid="17">Packages</span>
            </div>
            <div class="stat-item" style="align-items: flex-end;" vid="18">
                <span class="stat-value" style="color: var(--accent-red);" vid="19">{{ progress.est_finish }}</span>
                <span class="stat-label" vid="20">Est. Finish</span>
            </div>
        </div>
        
        <div class="progress-wrapper" vid="21">
            <div class="progress-container" vid="22">
                <div class="progress-bar" vid="23"></div>
            </div>
            <div class="progress-labels" vid="24">
                <span vid="25">{{ progress.completed }} COMPLETED</span>
                <span vid="26">{{ progress.remaining }} REMAINING</span>
            </div>
        </div>
    </section>

    <div class="list-header" vid="27">
        <div class="list-title" vid="28">Schedule</div>
    </div>

    <section class="stops-list" vid="29">
        
        <article class="stop-item completed" vid="30" *ngFor="let delivery of routes.deliveries" [routerLink]="['/delivery']" [queryParams]="{ id: delivery.id }">
            <div class="status-icon" vid="31">
                <svg viewBox="0 0 24 24" vid="32"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" vid="33"></path></svg>
            </div>
            <div class="stop-details" vid="34">
                <div class="customer-name" vid="35">{{ delivery.name }}</div>
                <div class="address" vid="36">{{ delivery.address.line1 }}</div>
            </div>
            <div class="stop-meta" vid="37">
                <div class="eta" vid="38">{{ delivery.eta }}</div>
                <div class="package-pill" vid="39">
                    <svg viewBox="0 0 24 24" vid="40"><path d="M21 16.5c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18-.21 0-.41-.06-.57-.18l-7.9-4.44A.991.991 0 013 16.5v-9c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18.21 0 .41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9zM12 4.15L6.04 7.5 12 10.85l5.96-3.35L12 4.15zM5 15.91l6 3.38v-6.71L5 9.21v6.7zM19 15.91v-6.7l-6 3.37v6.71l6-3.38z" vid="41"></path></svg>
                    {{ delivery.items.length }}
                </div>
            </div>
        </article>

    </section>

    <button class="fab" aria-label="Navigate" vid="75">
        <svg viewBox="0 0 24 24" vid="76">
            <polyline points="9 18 15 12 9 6" vid="77"></polyline>
        </svg>
    </button>
